// components/onboarding/OnboardingHeader.jsx - Enterprise Grade
import React from 'react';
import { motion } from 'framer-motion';

const OnboardingHeader = () => {
  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="relative bg-white/80 backdrop-blur-xl border-b border-gray-100 shadow-sm"
    >
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-50/50 via-transparent to-purple-50/50 pointer-events-none" />
      
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-5">
          {/* Logo Section */}
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="flex items-center gap-3 cursor-pointer"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-indigo-600 blur-lg opacity-20 rounded-2xl" />
              <img
                src="/logo.png"
                alt="Wayuvega"
                className="relative h-10 w-auto object-contain transition-transform duration-300"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                Wayuvega
              </span>
              <span className="text-xs text-gray-500 font-medium tracking-wide">
                Enterprise Logistics Platform
              </span>
            </div>
          </motion.div>

          {/* Support Badge */}
          <div className="hidden sm:flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-full border border-blue-100">
            <div className="flex items-center gap-2">
              <div className="relative">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                <div className="absolute inset-0 w-2 h-2 bg-green-500 rounded-full animate-ping opacity-75" />
              </div>
              <span className="text-sm font-semibold text-gray-700">24/7 Support</span>
            </div>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default OnboardingHeader;
